<!-- eslint-disable max-len -->
<template>
  <div
    v-if="listPages"
    class="container-pages-list">
    <div
      v-for="valParent in isParent"
      :key="valParent.id"
      class="menu-row-access-application">
      <b-row class="pr-2">
        <b-col
          cols="5"
          class="d-flex">
          <img
            :src="valParent.icon_grey"
            height="20"
            width="20"
            class="m__t--5">
          <div class="m__l--10">
            <div class="page-name">{{ valParent.name.toUpperCase() }}</div>
            <div class="page-id">{{ valParent.id }}</div>
          </div>
        </b-col>
        <b-col
          cols="6"
          class="border-left">
          <div class="page-type"> {{ valParent.type === 'visible' ? 'VISIBLE AT MENU' : 'MENU TITLE' }} </div>
        </b-col>
        <b-col
          v-if="valParent.type === 'visible'"
          cols="1">
          <j-toggle
            v-if="type === 'privilege'"
            v-model="valParent.active_privilege"
            @input="changeToggle($event, valParent)"/>
          <img
            v-else
            src="@/assets/icon/setting.svg"
            class="cursor-pointer"
            width="23px"
            height="23px"
            @click="openSetting(valParent)"
          >
        </b-col>
      </b-row>

      <div
        v-for="valChild in getSubPageByParent(valParent.id)"
        :key="valChild.id"
        class="menu-row p__l--50 m__t--10 m__b--10 child-row"
        style="margin-left: 20px;">
        <b-row class="pr-2">
          <b-col
            cols="5"
            class="d-flex">
            <img
              :src="valChild.icon_grey"
              height="16"
              width="16"
              class="m__t--5">
            <div class="m__l--10">
              <div class="page-name">{{ valChild.name.toUpperCase() }}</div>
              <div class="page-id">{{ valChild.id }}</div>
            </div>
          </b-col>
          <b-col
            cols="6"
            class="border-left">
            <div class="page-type"> {{ valChild.type === 'visible' ? 'VISIBLE AT MENU' : 'MENU TITLE' }} </div>
          </b-col>
          <b-col cols="1">
            <j-toggle
              v-if="type === 'privilege'"
              v-model="valChild.active_privilege"
              @input="changeToggle($event, valChild)"/>
            <img
              v-else
              src="@/assets/icon/setting.svg"
              class="cursor-pointer"
              width="23px"
              height="23px"
              @click="openSetting(valChild)"
            >
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listPages: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => '',
    },
  },

  computed: {
    isParent() {
      return this.listPages.filter(valParent => valParent.parent_id === 0)
        .sort((a, b) => a.order - b.order);
    },
  },

  methods: {
    getSubPageByParent(parentId) {
      return this.listPages.filter(page => page.parent_id === parentId)
        .sort((a, b) => a.order - b.order);
    },

    changeToggle(event, data) {
      this.$emit('change-toggle', event, data);
    },

    openSetting(data) {
      this.$emit('open-setting', data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access/components/jPagesList.vue